// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../endOfMinute/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var endOfMinute = convertToFP(fn, 1);
export default endOfMinute;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/endOfMinute/index.js
// module id = 863
// module chunks = 0